export default "__VITE_ASSET__BCYG_O6X__"